import React from "react";
import { LOGO_IMAGE } from "../../data/hseData";

export const Logo = ({ size = "md", tagline = true }) => {
  const sizes = {
    sm: { img: "h-8", tag: "text-[9px]" },
    md: { img: "h-10", tag: "text-[10px]" },
    lg: { img: "h-14", tag: "text-xs" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <a href="#home" data-testid="brand-logo" className="flex items-center gap-3 select-none">
      <img src={LOGO_IMAGE} alt="HSE Soluções e Serviços" className={`${s.img} w-auto object-contain bg-white p-1 border border-white/10`} />
      {tagline && (
        <div className="hidden sm:flex flex-col leading-none border-l border-white/15 pl-3">
          <span className={`font-condensed uppercase ${s.tag} tracking-[0.3em] text-white font-semibold`}>Soluções</span>
          <span className={`font-condensed uppercase ${s.tag} tracking-[0.3em] text-white/50`}>& Serviços</span>
        </div>
      )}
    </a>
  );
};

export default Logo;
